import React, { useState } from 'react';
import { login } from '../services/api';
import {
    useLanguage,
    setLanguage,
    setTenantCurrencyState
} from '../lang/useLanguage';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { t, lang } = useLanguage();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await login(username, password);
            localStorage.setItem('token', res.data.access_token);
            localStorage.setItem('username', username);
            localStorage.setItem('role', res.data.role);
            localStorage.setItem('tenant_id', res.data.tenant_id || '');
            localStorage.setItem('data_source', res.data.data_source || 'simulation');

            // Tenant locale/currency preference is authoritative after login.
            if (res.data.default_language) {
                setLanguage(res.data.default_language);
            }

            setTenantCurrencyState({
                currency_code: res.data.currency_code,
                currency_explicit: res.data.currency_explicit
            });

            if (username === 'superadmin') {
                window.location.href = '/superadmin';
            } else {
                window.location.href = '/dashboard';
            }
        } catch (err) {
            console.log('Hata:', err);
            setError(t.login.error + ': ' + (err.message || ''));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0e1a 0%, #111827 50%, #0f172a 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Arka plan efekti */}
            <div style={{
                position: 'absolute',
                width: '600px', height: '600px',
                background: 'radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 70%)',
                top: '-100px', left: '-100px',
                borderRadius: '50%'
            }} />
            <div style={{
                position: 'absolute',
                width: '400px', height: '400px',
                background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, transparent 70%)',
                bottom: '-50px', right: '-50px',
                borderRadius: '50%'
            }} />

            {/* Dil Seçici */}
            <div style={{ position: 'absolute', top: 20, right: 20, display: 'flex', gap: 6 }}>
                {['tr', 'en'].map(l => (
                    <button key={l} onClick={() => setLanguage(l)} style={{
                        padding: '6px 12px', borderRadius: 8, cursor: 'pointer',
                        border: `1px solid ${lang === l ? '#3b82f6' : '#2d3748'}`,
                        background: lang === l ? 'rgba(59,130,246,0.2)' : 'rgba(15,23,42,0.8)',
                        color: lang === l ? '#60a5fa' : '#64748b',
                        fontSize: 12, fontWeight: 700,
                    }}>{l.toUpperCase()}</button>
                ))}
            </div>

            <div style={{
                background: 'rgba(26,34,54,0.9)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(59,130,246,0.2)',
                borderRadius: '20px',
                padding: '48px',
                width: '100%',
                maxWidth: '420px',
                boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
                position: 'relative',
                zIndex: 1
            }}>
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: '36px' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '64px', height: '64px',
                        background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                        borderRadius: '16px',
                        marginBottom: '16px',
                        boxShadow: '0 8px 24px rgba(59,130,246,0.3)'
                    }}>
                        <span style={{ fontSize: '28px' }}>🏭</span>
                    </div>
                    <h1 style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#f1f5f9',
                        letterSpacing: '-0.5px'
                    }}>Opement Smart Factory System</h1>
                    <p style={{ color: '#64748b', fontSize: '13px', marginTop: '4px' }}>
                        {t.login.system}
                    </p>
                </div>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', color: '#94a3b8', fontSize: '13px', fontWeight: '500', marginBottom: '8px' }}>
                            {t.login.username}
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="kullanici_adi"
                            required
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                background: 'rgba(15,23,42,0.8)',
                                border: '1px solid #2d3748',
                                borderRadius: '10px',
                                color: '#f1f5f9',
                                fontSize: '14px',
                                outline: 'none',
                                transition: 'border-color 0.2s',
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                            onBlur={(e) => e.target.style.borderColor = '#2d3748'}
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', color: '#94a3b8', fontSize: '13px', fontWeight: '500', marginBottom: '8px' }}>
                            {t.login.password}
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            required
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                background: 'rgba(15,23,42,0.8)',
                                border: '1px solid #2d3748',
                                borderRadius: '10px',
                                color: '#f1f5f9',
                                fontSize: '14px',
                                outline: 'none',
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                            onBlur={(e) => e.target.style.borderColor = '#2d3748'}
                        />
                    </div>

                    {error && (
                        <div style={{
                            background: 'rgba(239,68,68,0.1)',
                            border: '1px solid rgba(239,68,68,0.3)',
                            borderRadius: '8px',
                            padding: '10px 14px',
                            color: '#f87171',
                            fontSize: '13px',
                            marginBottom: '16px'
                        }}>
                            ⚠️ {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            padding: '13px',
                            background: loading ? '#1e3a5f' : 'linear-gradient(135deg, #3b82f6, #2563eb)',
                            border: 'none',
                            borderRadius: '10px',
                            color: '#fff',
                            fontSize: '15px',
                            fontWeight: '600',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            boxShadow: loading ? 'none' : '0 4px 15px rgba(59,130,246,0.3)',
                            transition: 'all 0.2s',
                            letterSpacing: '0.3px'
                        }}
                    >
                        {loading ? `⏳ ${t.login.loggingIn}` : t.login.submit}
                    </button>
                </form>

                <p style={{ textAlign: 'center', color: '#334155', fontSize: '12px', marginTop: '24px' }}>
                    Opement Smart Factory System MES v1.0 · © 2026
                </p>
            </div>
        </div>
    );
}
